import ReactModal from 'react-modal'
import styled from 'styled-components'

export const Modal = styled(ReactModal)`
  left: 50%;
  outline: none;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);

  & > button {
    align-items: center;
    background-color: transparent;
    border: none;
    color: #FFF;
    cursor: pointer;
    display: flex;
    gap: 8px;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.25rem;
    outline: none;
    position: absolute;
    right: 0;
    text-align: left;
    top: -48px;

    & > img {
      height: 24px;
      width: 24px;
    }
  }
`
